var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.$style.switch},[_c('input',{class:_vm.$style.switchInput,attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.checked}}),_c('span',{ref:"interactElement",class:_vm.$style.switchHandle})])}
var staticRenderFns = []

export { render, staticRenderFns }